require('./channelsService');

'use strict';

angular.module('app.coverage.channels.channelsController', [
  'app.coverage.channels.channelsService'
])
  .controller('app.coverage.channels.channelsController', [
    '$scope', 'app.coverage.channels.channelsService', 'hostnameMatchService',
    function ($scope, channels, hostnameMatchService) {
      channels.retrieve();

      $scope.channels = channels;

      $scope.currentPlatform = window.location.platform(undefined, hostnameMatchService.hostname());

      $scope.gotoChannel = platform => {
        window.location = window.location.platform(platform, hostnameMatchService.hostname());
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/coverage/channels/channelsController.js